import { useDeliverySidebarItems } from '_/components/Deliveries/useDeliverySidebarItems';
import { DeliveryProvider, useDeliveryContext } from '_/contexts/DeliveryContext';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import React, { ReactNode, useEffect } from 'react';

interface DeliverySectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes DeliveryContext
 * Separated from provider to avoid circular dependency
 */
function DeliverySidebarManager({ children }: DeliverySectionProps) {
  const { deliveryId } = useDeliveryContext();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useDeliverySidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.DELIVERY);
    return () => {
      unregisterContext(CONTEXT_DEPTH.DELIVERY);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (deliveryId && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.DELIVERY);
    }
  }, [setSidebarItems, sidebarItems, deliveryId]);

  return <>{children}</>;
}

/**
 * DeliverySection - Wrapper for delivery-level pages
 * Combines provider and sidebar manager
 */
function DeliverySection({ children }: DeliverySectionProps) {
  return (
    <DeliveryProvider>
      <DeliverySidebarManager>{children}</DeliverySidebarManager>
    </DeliveryProvider>
  );
}

export default DeliverySection;
